<template>
  <div class="page not-found">

    <!-- Hero -->
    <div class="hero not-found-hero">

        <div class="hero-img">
          <picture>
            <source srcset="https://placeimg.com/1000/200/nature" media="(min-width: 576px)">
            <img srcset="https://placeimg.com/600/450/nature" alt="…">
          </picture>
        </div>

        <div class="hero-content">
            <h1 class="page-title">Page Not Found!</h1>
        </div>

    </div>

    <div class="container">

    </div>

  </div>
</template>

<script>
export default {
  created () {
    this.$emit('ready')
  }
}
</script>

<style>
</style>
